export default {
	methods: {
		parseUrl(url){
			const resParams = {};
			url
				.slice(1) // remove "?"
				.split('&')  // make an array like ["prop1=value1","prop2=value2"]
				.forEach( item => resParams[item.split('=')[0]] = item.split('=')[1] );
			return resParams; // output { prop1:value1, prop2:value2 }
		},
	}
};
